import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collapse",
  "use": "icon-collapse-usage",
  "viewBox": "0 0 1194 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1194 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-collapse\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 0h1194.666667v170.666667H0V0z m0 426.666667h597.333333v170.666666H0V426.666667z m0 426.666666h1194.666667v170.666667H0v-170.666667z m1194.666667-85.333333V256L750.933333 512 1194.666667 768z\" fill=\"#888888\" p-id=\"2050\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol